import React from 'react';
import cx from 'classnames';
import {ArrowStrokeLeft, ArrowStrokeRight} from '@epic-ui/icons';
import {
    DatePicker as MuiDatePicker,
    DatePickerProps as MuiDatePickerProps
} from '@material-ui/pickers';
import {useTheme} from '@material-ui/core/styles';

import {useStyles} from './RangePicker.styles';

const DatePicker = React.forwardRef(
    (
        {
            PopoverProps: {classes: popoverClasses = {}, ref: popoverRef, ...PopoverProps} = {},
            leftArrowButtonProps,
            rightArrowButtonProps,
            value,
            initialFocusedDate,
            ...props
        }: MuiDatePickerProps,
        ref: MuiDatePickerProps['ref']
    ) => {
        const classes = useStyles();
        const {spacing} = useTheme();

        return (
            <MuiDatePicker
                leftArrowIcon={<ArrowStrokeLeft />}
                rightArrowIcon={<ArrowStrokeRight />}
                minDate={new Date(new Date(2018, 0, 1))}
                maxDate={new Date()}
                value={value}
                orientation="portrait"
                initialFocusedDate={initialFocusedDate}
                leftArrowButtonProps={{
                    color: 'inherit',
                    ...leftArrowButtonProps
                }}
                rightArrowButtonProps={{
                    color: 'inherit',
                    ...rightArrowButtonProps
                }}
                PopoverProps={{
                    transformOrigin: {horizontal: 'center', vertical: spacing(-0.5)},
                    ...PopoverProps,
                    classes: {
                        ...popoverClasses,
                        paper: cx(classes.paper, popoverClasses.paper)
                    },
                    ref: popoverRef || null
                }}
                {...props}
                ref={ref}
            />
        );
    }
);

export default DatePicker;
